module.exports = __webpack_public_path__ + "43a2cdaeefd17b3eade9a0debf844e99.jpg";